import Vue from 'vue';
import Vuex from 'vuex';

import calculatorModule from './modules/calculator';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  modules: {
    calc: calculatorModule,
  },
  getters: {
    currentRegion: (state) => state.calc.selectedRegion,
    currentAquaculture: (state) => state.calc.selectedAquaculture,
    currentLocale: (state) => state.calc.currentLocale,
  },
});
